export default __webpack_public_path__ + "static/media/1-4-4.f029c2e8.webp";